import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./ClientStories.css";
import { FaQuoteLeft } from "react-icons/fa";

const stories = [
  {
    id: 1,
    name: "John Smith",
    role: "CEO, TechCorp",
    story:
      "Working with this team completely transformed our digital presence. They delivered high-quality solutions ahead of schedule and exceeded our expectations.",
    image: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    id: 2,
    name: "Sophia Lee",
    role: "Marketing Head, BrightMedia",
    story:
      "Their professionalism and innovative approach helped us scale faster. The collaboration was seamless and results were outstanding.",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    id: 3,
    name: "David Johnson",
    role: "Founder, StartupX",
    story:
      "They understood our vision from the start and turned it into a reality. A truly reliable partner for long-term growth.",
    image: "https://randomuser.me/api/portraits/men/76.jpg",
  },
];

const ClientStories = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // ✅ Initialize AOS
  }, []);

  return (
    <section className="client-stories-section" id="client-stories">
      <div className="client-stories-container">
        <h2 className="client-stories-title" data-aos="fade-up">
          Client Success Stories
          <span className="client-stories-underline"></span>
        </h2>

        <div className="client-stories-grid">
          {stories.map((story, index) => (
            <div
              className="client-stories-card"
              key={story.id}
              data-aos="fade-up"
              data-aos-delay={index * 200} // ✅ Stagger effect
            >
              <FaQuoteLeft className="client-stories-quote-icon" />
              <p className="client-stories-text">"{story.story}"</p>
              <div className="client-stories-info">
                <img
                  src={story.image}
                  alt={story.name}
                  className="client-stories-img"
                />
                <div>
                  <h4 className="client-stories-name">{story.name}</h4>
                  <p className="client-stories-role">{story.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientStories;
